import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

import { state } from './state'
import { mutations } from './mutations'
import { actions } from './actions'

import sps from './modules/spsModule'
import bestove from './modules/bestoveModule'

Vue.use(Vuex)

const store = new Vuex.Store({
  state,
  mutations,
  actions,
  modules: {
    sps,
    bestove
  },
  plugins: [
    createPersistedState({
      storage: window.sessionStorage
    })
  ],
  strict: true
})

export default store
